import { FEATURE_LOYALTY_UI_SINGLETON } from 'features/content/hooks/use-feature-loyalty-ui';

import { useFeatureLoyaltyBackgroundQuery } from 'generated/sanity-graphql';
import { buildImageUrl } from 'remote/build-image-url';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';
import { getDesignToken } from 'styles/constants';

import { ILoyaltyBackground } from './use-loyalty-background.types';

const useLoyaltyBackground = (): ILoyaltyBackground => {
  const { data } = useFeatureLoyaltyBackgroundQuery({
    variables: { featureLoyaltyUIId: FEATURE_LOYALTY_UI_SINGLETON },
  });
  const sanityProjectId = useFlag(LaunchDarklyFlag.SANITY_PROJECT_ID);

  const image = data?.LoyaltyUI?.imageBackground?.image;

  return {
    image: image ? buildImageUrl(image, sanityProjectId) : '',
    color: getDesignToken('color-contrast-background'),
  };
};

export default useLoyaltyBackground;
